import { createTheme } from '@mui/material/styles';

const customTheme = createTheme({
    palette: {
        text:{
            title: "#5e2103",
            main: {
                light: "#D5D5D5",
                normal: "#484848",
                dark: "#3b2617"
            },
            error: "#bd0d00"
        },
        background: {
            lighter: "#F4F5F8",
            light: "#bfbcba",
            main: "#73492a",
            dark: "#3b2617"
        },
    },
    typography: {
        fontFamily: [
            'PTRootUI',
            '-apple-system',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    }
})

export default customTheme;
